import { format } from "date-fns";
import Swal from "sweetalert2";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { salesRoutes } from "../../data";
import {
  useDeleteTempSaleMutation,
  useSaleByDateQuery,
} from "../../services/saleApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import ExportNav from "../Common/Nav/ExportNav";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { ImFileText2 } from "react-icons/im";
const Sales = () => {
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [warehouse, setWarehouse] = useState("allWh");
  const lang = useSelector((state) => state.languageReducer);

  const auth = signInUser();
  const { aamarId, storeSettings } = auth;
  // console.log("User", auth);
  const [q, setQ] = useState("");

  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useSaleByDateQuery({
      startDate,
      endDate,
      warehouse,
      aamarId,
      q,
    });

  const [sales, setSales] = useState([]);
  // console.log("sales", data);
  const [totalSales, setTotalSales] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);
  const [changeAmount, setChangeAmount] = useState(0);

  const [deleteSale] = useDeleteTempSaleMutation();

  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, warehouse]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  useEffect(() => {
    setSales(data);
    let total = 0;
    let totalReceive = 0;
    let changeAmount = 0;
    if (data?.length) {
      data.map((sale) => {
        total = total + sale.grossSale;
        totalReceive = totalReceive + sale.totalReceived;
        changeAmount = changeAmount + sale.changeAmount;
      });
    }
    setTotalSales(total);
    setTotalReceived(totalReceive);
    setChangeAmount(changeAmount);

    // isSuccess === true ? setLoader(false) : setLoader(true);
  }, [isSuccess, data, isLoading]);

  const handelDeleteSale = async (id) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Sale?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const data = {
        _id: id,
        updateUser: auth.id,
        status: "delete",
      };
      console.log(deleteSale(data));
    }
  };

  const handelSearchInvoice = (e) => {
    setQ(e.target.value);
    refetch();
  };

  // console.log("sales", sales);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
    // console.log("handle data:", e);

    // console.log('')
    // refetch();
  };
  // console.log("sales", sales);
  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["Sales Report"],

    [], // Empty row for spacing
  ];

  return (
    <div>
      <LoadingModal
        title={"Please Wait"}
        onShow={loader}
        handleClose={handleLoaderClose}
      ></LoadingModal>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Aamar-Dokan-SALE</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.allSales}></Header>
            <div className="row mt-3">
              {/* Date Range, Search, Warehouse */}
              <div className="col-md-6">
                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                  <DatePicker
                    selected={new Date(startDate)}
                    className="form-control"
                    onChange={(date) =>
                      setStartDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                    placeholderText="Start Date"
                  />
                  <DatePicker
                    selected={new Date(endDate)}
                    className="form-control"
                    onChange={(date) =>
                      setEndDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                    placeholderText="End Date"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Invoice ID"
                    onKeyUp={(e) => handelSearchInvoice(e)}
                    style={{ width: "35%" }}
                  />
                  {auth?.type === "admin" && (
                    <div
                      style={{
                        width: window.innerWidth >= 768 ? 280 : "100%",
                      }}
                    >
                      <WareHouseDW
                        id="warehouse"
                        name="warehouse"
                        handleOnChange={handleOnchangeWareHouseFrom}
                        className="form-control"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Export Navigation */}
              <div className="col-md-6 d-flex justify-content-end align-items-start">
                <ExportNav
                  preheader={preHeader}
                  Routes={salesRoutes}
                  title="Sales"
                  data={sales}
                />
              </div>
            </div>

            {/* <Link to="/category-sales" className="btn btn-dark float-end my-2  mx-2">Category Sales </Link> */}

            <div className="table-responsive">
              <table
                className="table table-striped align-middle"
                style={{ backgroundColor: "#F8F9FA" }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#F2652D", color: "white" }}>
                    <th>Invoice ID</th>
                    <th>Date</th>
                    <th>Biller</th>
                    <th>Warehouse</th>
                    <th>Customer</th>
                    <th className="text-center">Items</th>
                    <th className="text-center">Gross Total</th>
                    <th className="text-center">Paid</th>
                    <th className="text-center">Change</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sales?.length > 0 ? (
                    sales.map((sale) => (
                      <tr key={sale._id}>
                        <td>
                          <strong>{sale.invoiceId}</strong>
                        </td>
                        <td>
                          {sale.createdAt &&
                            format(
                              new Date(sale.createdAt),
                              "MM-dd-yyyy hh:mm a"
                            )}
                        </td>
                        <td>
                          {sale?.billerName || sale?.authorizedUser || "N/A"}
                        </td>
                        <td>{sale?.warehouseName}</td>
                        <td>{sale?.customerName || "Walkaway customer"}</td>
                        <td className="text-center">
                          {sale?.totalItem > 0 ? (
                            sale?.returnItemTotal > 0 ? (
                              <span>
                                {sale.totalItem}{" "}
                                <span
                                  className="text-danger"
                                  title="Returned items"
                                >
                                  (-{sale.returnItemTotal})
                                </span>
                              </span>
                            ) : (
                              sale.totalItem
                            )
                          ) : sale?.returnItemTotal > 0 ? (
                            <span
                              className="text-danger"
                              title="Returned items"
                            >
                              -{sale.returnItemTotal}
                            </span>
                          ) : sale?.grossSale < 0 ? (
                            <span
                              className="text-danger"
                              title="Returned items"
                            >
                              -1
                            </span>
                          ) : (
                            0
                          )}
                        </td>
                        <td
                          className={`text-center ${
                            sale?.grossSale < 0 ? "text-danger" : ""
                          }`}
                        >
                          {new Intl.NumberFormat().format(sale?.grossSale)}
                        </td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(sale?.totalReceived)}
                        </td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(sale?.changeAmount)}
                        </td>
                        <td>
                          {sale?.grossSale < 0 ||
                          (sale?.returnItemTotal > 0 && !sale?.totalItem) ||
                          sale?.status === "return" ? (
                            <span className="badge bg-warning text-dark">
                              Return
                            </span>
                          ) : sale.due ? (
                            <span className="badge bg-danger">Bill Due</span>
                          ) : (
                            <span
                              className={`badge ${
                                sale?.status === "complete"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {sale?.status === "complete"
                                ? "Complete"
                                : sale?.status}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <Link to={`/print/${sale._id}`} target="_blank">
                              <Icons.EyeOutline
                                className="text-primary"
                                size={22}
                              />
                            </Link>
                            {auth?.type === "admin" && (
                              <Icons.TrashOutline
                                className="text-danger cursor-pointer"
                                onClick={() => handelDeleteSale(sale._id)}
                                size={22}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={11}
                        style={{
                          height:'680px',
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <div
                          className="d-flex flex-column align-items-center justify-content-center text-muted w-100 h-100 py-5"
                          style={{ minHeight: "100%" }}
                        >
                          <ImFileText2
                            size={40}
                            className="mb-2 text-secondary"
                          />
                          <h6 className="fw-bold mb-0">No Sales Data Found</h6>
                          {/* <small className="text-muted">
                            Please check again later or apply different filters.
                          </small> */}
                        </div>
                      </td>
                    </tr>
                  )}

                  {sales?.length > 0 && (
                    <tr style={{ backgroundColor: "#f1f1f1" }}>
                      <td colSpan={5}></td>
                      <td className="text-center fw-bold">Total</td>
                      <td
                        className="text-center fw-bold"
                        style={{ color: "#F2652D" }}
                      >
                        {new Intl.NumberFormat().format(
                          parseFloat(totalSales).toFixed(2)
                        )}
                      </td>
                      <td
                        className="text-center fw-bold"
                        style={{ color: "#F2652D" }}
                      >
                        {new Intl.NumberFormat().format(
                          parseFloat(totalReceived).toFixed(2)
                        )}
                      </td>
                      <td
                        className="text-center fw-bold"
                        style={{ color: "#F2652D" }}
                      >
                        {new Intl.NumberFormat().format(
                          parseFloat(changeAmount).toFixed(2)
                        )}
                      </td>
                      <td colSpan={2}></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sales;
